// extracted by mini-css-extract-plugin
module.exports = {"cards":"_2MMmoy3EasdifV84wHBKFA","card":"_139aVTKm2ulc_jPct8G2GI"};